import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useInvoices} from '../hooks/useInvoices';

export const ReloadRecordsButton = () => {

    const {reloadRecords} = useInvoices();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reloadRecords()}/>
        </Box>
    );
};